import React from 'react'
import './pocket-logo.svg';
import Element from './Element';
import menuItems from './menuItems'

const url = new URL(window.location);
const selected = menuItems.find(mi => mi.url === url.pathname)



export default () => {
  return (
      <Element selectedItem={selected}
               onClick={mi => window.location.href = mi.url + '?src=top_navbar'}/>
  )
}
